import React, { useState ,useEffect} from 'react';
import { 
    UserCircle, Book, GraduationCap, Briefcase, AlertTriangle,
    CreditCard, FileText, Upload, Check,
    ArrowLeft, ArrowRight, Camera, CheckCircle,
    Mail, Phone, Globe, Calendar, MessageCircle
  } from 'lucide-react';
import { useUsers } from '../../../metodos/userContext';
import ProfileSkeleton from './PerfilUsuario';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import SelectorMaterias from '../../Utils/Selectores/Materias/selectorMaterias';
import ExperienciaLaboralForm from '../../Utils/selectorExperienciaLaboral';
import CuentasBancariasForm from '../../Utils/Selectores/Cuentas Bancarias/selectorCuentaBancaria';
import FileUploader from '../../../components/FileUploader';
import { useTutoresModel } from '../../../modelos/Tutores/modeloTutores';
import ErrorBoundary from '../../../views/Utils/ErrorBoundar';
import SelectorTipoServicios from '../../../views/Utils/selectorTipoServicios';

const CompletarPerfilNuevoTutor = () => {
    const { usuario, loading, error , recargarUsuario } = useUsers();
    const [paso, setPaso] = useState(1);
    const totalPasos = 6;
    const [registroCompleto, setRegistroCompleto] = useState(false);
    
    const {
        addRegistroCompletoTutor,
      } = useTutoresModel();
    const {
        // materias
        materias,
        isLoadingMaterias,
        errorMaterias,
        cargarMaterias
      } = useListasModel();
      // Estado para almacenar los datos del formulario
    const [formData, setFormData] = useState({
        tipoServicios: [],
        materias: [],
        experienciaLaboral: [],
        cuentas: [],
        hojadevida: null,
        fotoPerfil: null
      });

    useEffect(() => {
        cargarMaterias();
    }, []);

    // Función para actualizar las materias seleccionadas
    const actualizarMateriasSeleccionadas = (materiasSeleccionadas) => {
        setFormData({...formData, materias: materiasSeleccionadas});
    };

    const envioFormulario = async(e)  => {
        e.preventDefault();
        const respuesta = await addRegistroCompletoTutor(formData,usuario);
        console.log("la respuesta es ",respuesta);
        if (respuesta) {
          await recargarUsuario();
        }
       
    };
  
    // Mostrar carga de usuario
    if (loading) {
        return <ProfileSkeleton />;
    }

    // Mostrar error de usuario
    if (error || !usuario) {
        return (
        <div className="flex flex-col items-center justify-center h-screen">
            <AlertTriangle className="w-12 h-12 text-red-500 mb-4" />
            <h2 className="text-xl font-bold text-gray-800 mb-2">No se pudo cargar el perfil</h2>
            <p className="text-gray-600">{error || "Ocurrió un error al cargar los datos del tutor"}</p>
        </div>
        );
    }

    // Función para manejar el cambio de paso
    const cambiarPaso = (nuevoPaso) => {
        if (nuevoPaso > 0 && nuevoPaso <= totalPasos) {
        setPaso(nuevoPaso);
        } else if (nuevoPaso > totalPasos) {
        // Si hemos llegado al final, mostrar mensaje de completado
        setRegistroCompleto(true);
        }
    };

    if(usuario.infoCompletaUsuario && usuario.rol=="PROSPECTO"){
        if(usuario.infoCompletaUsuario && usuario.rol === "PROSPECTO") {
            return (
              <div className="flex justify-center items-center min-h-screen bg-gray-100">
                <div className="max-w-2xl w-full mx-4 my-6 bg-white rounded-lg shadow-md overflow-hidden">
                  {/* Header con logo */}
                  <div className="bg-green-500 text-white p-4 flex justify-between items-center">
                    <div className="text-xl">∑ ÷ ∞</div>
                    <h1 className="text-4xl font-bold">EduSmart</h1>
                    <div className="text-xl">🎓 📚</div>
                  </div>
                  
                  {/* Mensaje de proceso completo */}
                  <div className="p-6">
                    <h2 className="text-xl font-bold text-green-600 mb-2">Proceso completado</h2>
                    
                    <div className="flex flex-col items-center justify-center py-8 space-y-8">
                      <div className="bg-green-100 rounded-full p-5">
                        <CheckCircle className="w-20 h-20 text-green-500" />
                      </div>
                      
                      <div className="text-center space-y-4">
                        <h3 className="text-2xl font-bold text-gray-800">¡Tu proceso está completo!</h3>
                        <p className="text-gray-600 max-w-md mx-auto">
                          Has completado exitosamente tu proceso de registro como tutor. Nuestro equipo está revisando tu solicitud y nos comunicaremos contigo próximamente.
                        </p>
                      </div>
                      
                      <div className="bg-blue-50 border-l-4 border-blue-500 p-4 text-blue-700 w-full max-w-md">
                        <div className="flex items-start">
                          <MessageCircle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
                          <p>Recibirás una notificación via whatsapp sobre tu solciitud, normalmente tardamos menos de 15 dias en dar revision.</p>
                        </div>
                      </div>
                      
                      <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md">
                        
                        
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
    }

    return(
        <div className="flex flex-col w-full max-w-4xl mx-auto bg-gray-50 min-h-screen p-6">
            {/* Cabecera con logo e indicador de progreso */}
            <div className="bg-white shadow-md rounded-lg p-6 mb-6">
            <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Completa tu perfil de Tutor</h1>
            <div className="text-sm text-gray-500">Paso {paso} de {totalPasos}</div>
            </div>
        
        {/* Barra de progreso */}
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div 
            className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
            style={{ width: `${(paso/totalPasos) * 100}%` }}
          ></div>
        </div>
        
        {/* Indicador de pasos */}
        <div className="flex justify-between text-xs text-gray-400 mt-2">
          <div className={`${paso >= 1 ? 'text-blue-600 font-medium' : ''}`}>Servicios</div>
          <div className={`${paso >= 2 ? 'text-blue-600 font-medium' : ''}`}>Materias</div>
          <div className={`${paso >= 3 ? 'text-blue-600 font-medium' : ''}`}>Experiencia</div>
          <div className={`${paso >= 4 ? 'text-blue-600 font-medium' : ''}`}>Cuentas</div>
          <div className={`${paso >= 5 ? 'text-blue-600 font-medium' : ''}`}>Anexos</div>
          <div className={`${paso >= 6 ? 'text-blue-600 font-medium' : ''}`}>Foto</div>
        </div>
            </div>

            {/* Contenedor del formulario */}
            <div className="bg-white shadow-md rounded-lg p-6 mb-6">  
              <ErrorBoundary>
                {/* Paso 1: Tipos de servicios */}
                {paso === 1 && (
                <div className="space-y-6">
                  <SelectorTipoServicios
                    //serviciosSeleccionados={formData.tipoServicios}
                    formData={formData}
                    setFormData={setFormData}
                  />
                </div>
                )}

                {/* Paso 2: Materias */}
                {paso === 2 && (
                    <div>
                    {isLoadingMaterias ? (
                        <div className="flex justify-center items-center h-40">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        </div>
                    ) : errorMaterias ? (
                        <div className="text-red-500 p-4 border border-red-200 rounded-md">
                        Error al cargar materias: {errorMaterias}
                        </div>
                    ) : (
                        <SelectorMaterias 
                        materias={materias} 
                        materiasSeleccionadas={formData.materias}
                        setMateriasSeleccionadas={actualizarMateriasSeleccionadas}
                        />
                    )}
                    </div>
                )}
        
                {/* Paso 3: Experiencia Laboral */}
                {paso === 3 && (
                <ExperienciaLaboralForm 
                    formData={formData} 
                    setFormData={setFormData} 
                />
                )}
                
                {/* Paso 4: Cuentas Bancarias */}
                {paso === 4 && (
                <CuentasBancariasForm 
                  formData={formData} 
                  setFormData={setFormData} 
                />
                )}
                
                {/* Paso 5: Anexos (Hoja de Vida) */}
                {paso === 5 && (
                <div className="space-y-6">
                    <div className="flex items-center text-xl font-bold text-gray-800 mb-4">
                    <FileText className="mr-3 w-6 h-6 text-blue-500" />
                    Hoja de Vida
                    </div>
                    
                    <p className="text-gray-600 mb-4">
                    Sube tu hoja de vida o curriculum vitae para conocer tu trayectoria profesional.
                    </p>
                    
                    
                    <FileUploader 
                    formData={formData}
                    setFormData={setFormData}
                    fieldName="hojadevida"
                    allowedTypes={[
                      'application/pdf',
                      'application/msword',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    ]}
                    maxSize={10 * 1024 * 1024}
                    label="hoja de vida"
                    multiple={false}
                    />
                    
                    
                    <div className="text-sm text-gray-500 bg-blue-50 p-4 rounded-lg">
                    <p>Tu hoja de vida será visible para el personal de reclutamiento.</p>
                    </div>
                </div>
                )}
                
                {/* Paso 6: foto de perfil  */}
                {paso === 6 && (
                  <div className="space-y-6">
                    <div className="flex items-center text-xl font-bold text-gray-800 mb-4">
                        {/* Cambié el ícono a uno más apropiado para un usuario/perfil */}
                        <UserCircle className="mr-3 w-6 h-6 text-blue-500" /> 
                        Foto de perfil
                    </div>
                    
                    <p className="text-gray-600 mb-4">
                      Por favor, sube una <strong>foto para tu perfil</strong>. Es importante que <strong>sea una foto tuya</strong>, de tipo profesional y donde tu rostro se vea claramente. ¡Así los estudiantes podrán conocerte!
                    </p>
                    
                    
                    <FileUploader 
                    formData={formData} 
                    setFormData={setFormData} 
                    fieldName="fotoPerfil"
                    allowedTypes={['image/jpeg', 'image/jpg']}
                    maxSize={5 * 1024 * 1024}
                    label="hoja de vida"
                    multiple={false}
                    />
                    
                </div>
                )}
              </ErrorBoundary>  
                
            </div>

            {/* Botones de navegación */}
            <div className="flex justify-between">
                <button
                onClick={() => cambiarPaso(paso - 1)}
                disabled={paso === 1}
                className={`px-6 py-2 rounded-md flex items-center ${
                    paso === 1 ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
                }`}
                >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Anterior
                </button>
                
                {paso < totalPasos ? (
                <button
                    onClick={() => cambiarPaso(paso + 1)}
                    className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center"
                >
                    Siguiente
                    <ArrowRight className="w-4 h-4 ml-2" />
                </button>
                ) : (
                <button
                    onClick={envioFormulario}
                    className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center"
                >
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Completar Registro
                </button>
                )}
            </div>


        </div>
    )
        
}

export default CompletarPerfilNuevoTutor;